/**
 * Internal dependencies
 */
import { getEditedLayout } from 'state/dashboard-layouts/selectors';
import getLayoutId from './get-layout-id';

export default (state) => getEditedLayout(state, getLayoutId(state));
